module.exports = __webpack_public_path__ + "img/tabbar01_.f375c12a.png";